import { render, staticRenderFns } from "./ReprsentativeSwitch.vue?vue&type=template&id=4e9df22b&scoped=true"
import script from "./ReprsentativeSwitch.vue?vue&type=script&lang=js"
export * from "./ReprsentativeSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9df22b",
  null
  
)

export default component.exports